import { Loader2 } from "lucide-react";
import { cn } from "@/lib/cn";

/**
 * Spinner — Volume 03 §23. Dùng trong button hoặc vùng nhỏ,
 * không hiển thị spinner toàn trang lâu mà không có context.
 */
export function Spinner({
  className,
  label = "Đang tải…",
}: {
  className?: string;
  label?: string;
}) {
  return (
    <span role="status" className="inline-flex items-center gap-2 text-muted">
      <Loader2 className={cn("size-4 animate-spin", className)} aria-hidden="true" />
      <span className="sr-only">{label}</span>
    </span>
  );
}
